
export type ExploreContentItemContentOneOfReferencedTweetType = typeof ExploreContentItemContentOneOfReferencedTweetType[keyof typeof ExploreContentItemContentOneOfReferencedTweetType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExploreContentItemContentOneOfReferencedTweetType = {
  REPLIED_TO: 'REPLIED_TO',
  QUOTED: 'QUOTED',
  RETWEETED: 'RETWEETED',
} as const;
